export function formatCurrency(value: number | undefined | null, _language: string) {
  if (typeof value === "number") {
    const farmattedValue = value.toLocaleString("en", {
      style: 'currency',
      currency: "CAD",
      currencyDisplay: "code",
    }).replaceAll("CAD", '').trim()
    return farmattedValue
  }
  return value
}

export const formatPercentage = (percentage: number) => {
  const roundedPercentage = Number(percentage.toFixed(1));
  return Object.is(roundedPercentage, -0) ? "0.0" : roundedPercentage.toFixed(1);
}

export function formatRoll(roll: string | undefined | null) {
  if (typeof roll === "string") {
    if (roll.length !== 15) {
      return roll
    }
    const formatted = roll.slice(0, 4) + " " + roll.slice(4, 7) + " " + roll.slice(7, 10) + " " + roll.slice(10, 15)
    return formatted
  }
  return roll
}

export function cleanRoll(roll: string | undefined | null) {
  if (typeof roll !== "string") {
    return roll || "";
  }
  return roll.replace(/[\s\-_.]/g, '')
}

export function commaSeparate(value: string | number | null | undefined | boolean) {
  if (value === null || value === undefined) {
    return value
  }

  value = String(value)
  if (!(/^-?\d+(?:\.\d+)?$/.test(value))) {
    return value
  }

  const [intPart, decPart] = value.split('.')
  const isNegative = intPart.startsWith('-')
  const result = isNegative ? intPart.slice(1) : intPart
  const formatted = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return (isNegative ? '-' : '') + formatted + (decPart ? '.' + decPart : '')
}